import React, { FC, PropsWithChildren } from 'react';
import { SearchSection } from './search-section';

interface SearchWrapProps {
  searchData?: Record<string, any[]>;
}

export const SearchWrap: FC<PropsWithChildren<SearchWrapProps>> = (props) => {
  const { searchData, children } = props;

  if (!searchData) return <>{children}</>;

  return <SearchSection searchData={searchData}>{children}</SearchSection>;
};
